<template>
  <div>

    <b-row>
    <list-modal ref="devicesList"/>
    </b-row>


    <b-row>
      <b-col v-for="item in data.status">
    <!----->
        <b-card no-body class="card-statistics" >
          <b-card-body class="statistics-body">
            <div class="d-flex align-items-center justify-content-center">

    <!--            <b-col cols="12" sm="6" md="6" lg="3" xl="3" v-for="item in data.status" class="d-flex flex-column">-->
                <b-col>

                  <div class="d-flex flex-row justify-content-center">
                    <div class="flex-column my-2">
                      <feather-icon size="33" :icon="item.icon" />
                    </div>
                  </div>

                  <div class="d-flex flex-row justify-content-center my-1">
                    <div class="flex-column mb-2">
                      <vue-apex-charts :options="getDeviceStatChartOptions(item)" :series="item.count" :height="120" />
                    </div>
                  </div>

                  <div></div>
                  <div class="d-flex flex-row justify-content-center">
                    <div v-for="(value, index) in item.filters" class="d-flex flex-column mx-1 p-1">
                      <div class="d-flex flex-row justify-content-center">
                        <div class="flex-column" :style="`width: 10px;height: 30px;background-color: ${item.color[index]};`">
                        </div>
                        <div class="flex-column" style="margin-inline: 8px;">
                          <h3>{{ item.count[index] }}</h3>
                        </div>
                      </div>
                      <div class="flex-row">
                        <p class="fs-1">{{ $t(item.label[index]) }}</p>
                      </div>
                      <div class="flex-row">
                        <b-button @click="devicesList.showModal({
                        title:item.label[index],
                        exportables:[
                          {label:'Excel', export:`${item.key[index]}DevicesList`, exporter:'xlsx', params:$store.getters['dashBoardFilter/getFilterData']},
                          {label:'PDF', export:`${item.key[index]}DevicesList`, exporter:'pdf', params:$store.getters['dashBoardFilter/getFilterData']}
                        ],
                        fields:[
                          {key:'name', label:'name'},
                          {key:'contract', label:'contract'},
                          {key:'category', label:'category'},
                          {key:'lastUpdate', label:'last update'}
                        ],
                        list:getDevicesStatus(value)
                        })" variant="primary"
                                  class="w-100"><feather-icon size="10" icon="ListIcon" /></b-button>
                      </div>
                    </div>
                  </div>

                </b-col>

            </div>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>


      <!----->
    <b-card>
        <div class="d-flex justify-content-center mb-1 border p-1">
          <div class="d-flex flex-column">
            <div class="d-flex flex-row justify-content-center mb-2">
              <feather-icon size="33" icon="CalendarIcon" />
            </div>
            <div class="d-flex flex-row justify-content-center mb-1">
              <h2 class="bold">{{ $t('Day Statistics') }}</h2>
            </div>

          </div>

        </div>
        <div class="d-flex justify-content-center">

          <b-row>
            <b-col v-for="item in data.day" cols="6" lg="3" class="mb-2">
              <div class="d-flex flex-row justify-content-center">
                <div class="flex-column" style="text-align: center;">
                  <p class="fs-1">{{ $t(item.label) }}</p>
                </div>
              </div>
              <div class="flex-row justify-content-center">
                <h3 style="text-align: center;">{{ item.value }}</h3>
              </div>
              <div class="flex-row justify-content-center">
                <p style="text-align: center;">{{ $t(item.unit) }}</p>
              </div>
              <div class="flex-row">
                <b-button @click="devicesList.showModal({
            title:item.label,
            exportables:[
                  {label:'Excel', export:item.export, exporter:'xlsx', params:$store.getters['dashBoardFilter/getFilterData']},
                  {label:'PDF', export:item.export, exporter:'pdf', params:$store.getters['dashBoardFilter/getFilterData']}
            ],
            fields:[
              {key:'name', label:'name'},
              {key:'contract', label:'contract'},
              {key:'category', label:'category'},
              {key:'lastUpdate', label:'last update'},
              {key:item.key, label:item.unit}
            ],
            list:getDevicesStatus(item.filters)
            })" variant="primary" class="w-100"><feather-icon size="10" icon="ListIcon" /></b-button>
              </div>
            </b-col>
          </b-row>

<!--          <div v-for="item in data.day" class="d-flex flex-column mx-1 p-1 border">-->

<!--          </div>-->



        </div>

      </b-card>


  </div>
</template>

<script>
import {
  BFormGroup, BCard, BCardHeader,
  BCardTitle, BCardText, BCardBody,
  BRow, BCol, BMedia, BMediaAside,
  BAvatar, BMediaBody, BLink, BContainer, BTable, BPagination, BFormSelect, BButton, VBTooltip
} from 'bootstrap-vue'

import { ref } from '@vue/composition-api'
import TableWidget from './modals/TableWidget.vue';
import { OrbitSpinner } from 'epic-spinners'
import axios from '@/libs/axios'
import Ripple from 'vue-ripple-directive'
import VueApexCharts from 'vue-apexcharts'
import data from '@/router/routes/ui-elements';
import ListModal from './modals/ListModal.vue';
import store from '@/store'
export default {
  components: {
    BButton,
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardText,
    BCardBody,
    BMedia,
    BAvatar,
    BMediaAside,
    BMediaBody,
    BLink,
    BContainer,
    BTable,
    BPagination,
    BFormGroup,
    BFormSelect,
    OrbitSpinner,
    TableWidget,
    VueApexCharts,
    ListModal
  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },

  props: {
    data: {
      type: Object,
      default: () => ({status:[], day:[]}),
    }
  },

  setup(props, { root }) {

    const devicesList = ref(null)


    const getDevicesStatus = (filters) => {
      return new Promise((resolve, reject) => {

        let params = {
          type:'currentStatus',
          needPagination:false
        }

        if (filters !== undefined) {
          Object.assign(params, filters)
        }

        let dashboardFilters  = store.getters['dashBoardFilter/getFilterData']

        if (dashboardFilters !== undefined) {
          Object.assign(params, dashboardFilters)
        }

        axios.post(`reports`, params)
        .then(res => {
          resolve(Object.values(res.data.data))
        })
        .catch(reason => reject(reason.response))
    })
    }

    const show = ref(false);
    const exportLoading = ref(false)

    const modalData = ref([]);
    const fields = [
      { "key": "id", "label": root.$t("id") },
      { "key": "name", "label": root.$t("name") },
      { "key": "contract", "label": root.$t("contract"), "sortable": true },
      { "key": "category", "label": root.$t("categoty"), "sortable": true, formatter: (v)=> root.$t(v) },
      { "key": "lastupdate", "label": root.$t("last update"), "sortable": true }
    ]
    const title = ref("")
    const dashDate = ref("");

    const showList = (newTitle, list) => {
      show.value = true;
      modalData.value = list;
      title.value = newTitle;
    }

    const exportData = (listType, exportType, data) => {
      const d = new Date();
      let cdate = d.getFullYear() + "-" +
        ("00" + (d.getMonth() + 1)).slice(-2) + "-" +
        ("00" + d.getDate()).slice(-2) + " " +
        ("00" + d.getHours()).slice(-2) + ":" +
        ("00" + d.getMinutes()).slice(-2) + ":" +
        ("00" + d.getSeconds()).slice(-2)

      const postedData = {
        "exporter": exportType,
        "export": listType + "DevicesList",
      }

      return new Promise(() => {
        exportLoading.value = true;
        axios.post(`export/`, postedData, {
          responseType: 'blob'
        })
          .then(response => {
            const type = response.headers['content-type']
            const blob = new Blob([response.data], { type: type, encoding: 'UTF-8' })
            exportLoading.value = false;
            const link = document.createElement('a')
            link.href = window.URL.createObjectURL(blob)
            link.download = 'file' + cdate + '.' + exportType
            link.click()
          })
          .catch(reason => exportLoading.value = false)
      })

    }

    const getDeviceStatChartOptions = (item) => {
      return {
        chart: {
          type: 'donut',

          toolbar: {
            show: false,
          },
          dropShadow: {
            enabled: true,
            top: 0,
            left: 0,
            blur: 5,
            opacity: 0.2
          }
        },
        dataLabels: {
          enabled: true,
          style: {
            fontSize: '10px',
            fontWeight: 'bold'
          }
        },
        legend: { show: false, position: 'top' },
        labels: item.label.map((l) => root.$t(l)),
        stroke: {},
        colors: item.color,
        grid: {
          padding: {
            right: 0,
            bottom: 0,
            left: 0,
          },
        },
        plotOptions: {
          pie: {
            expandOnClick: false,
            donut: {
              labels: {
                show: true,
                name: {
                  offsetY: 15,
                },
                value: {
                  offsetY: -15
                },
                total: {
                  show: true,
                  offsetY: 15,
                  label: ''
                },
              },
            },
          },
        },
        fill: {
          type: "gradient",
          gradient: {
            shade: "dark",
            type: "vertical",
            shadeIntensity: 0.2
          }
        }
      }
    }





    return {
      showList,
      show,
      modalData,
      fields,
      title,
      dashDate,
      exportLoading,
      exportData,
      getDeviceStatChartOptions,
      devicesList,
      getDevicesStatus
    }

  }
}
</script>
<style scoped>
span.b-avatar {
  /* box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px; */
  box-shadow: rgba(50, 50, 93, 0.25) 0px 50px 100px -20px, rgba(0, 0, 0, 0.3) 0px 30px 60px -30px, rgba(10, 37, 64, 0.35) 0px -2px 6px 0px inset;

}

.h10 {
  height: 10% !important;
}

span.b-avatar:hover {
  box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;

}
</style>